<div class="trust-owner-container">
  <c11n-dropdown
    appDropdownTypeahead
    *ngIf="!fromVgTable"
    id="trust-owner-dropdown"
    [labelText]="ACCOUNT_DETAILS_TRUST_NAME"
    [menuData]="trustOptions"
    [placeholderText]="'Make a selection'"
    [activeItems]="selectedTrustId ? [selectedTrustId] : []"
    (stateChange)="onTrustSelectionChange($event)">
  </c11n-dropdown>

  <!-- Description text under trust dropdown -->
  <p *ngIf="hasTrustsAvailable()" class="trust-dropdown-description">
    {{ ACCOUNT_DETAILS_REQUIRED_FIELDS }}
  </p>

  <!-- Trust detail fields - show after selection -->
  <ng-container>
    <!-- Row with Settlor and Trust Type side by side -->
    <div class="trust-field-row">
      <div class="trust-field" [class.disabled]="!selectedTrustId">
        <div class="dropdown-wrapper" [style.pointer-events]="!selectedTrustId ? 'none' : 'auto'">
          <c11n-dropdown
            appDropdownTypeahead
            id="trust-settlor-dropdown"
            [labelText]="'Settlor'"
            [menuData]="settlorOptions"
            [placeholderText]="'Select'"
            [activeItems]="selectedSettlor ? [selectedSettlor] : []"
            (stateChange)="onSettlorChange($event)">
          </c11n-dropdown>
          <c11n-hint-error
            [hasError]="!validSettlorInput"
            [size]="'medium'"
            [hintText]="TRUST_DETAILS_SETTLOR_DESC"
            [errorText]="'Please make a selection'"
            hintErrorId="trust-settlor-error"
          ></c11n-hint-error>
        </div>
      </div>

      <div class="trust-field" [class.disabled]="!selectedTrustId">
        <div class="dropdown-wrapper" [style.pointer-events]="!selectedTrustId ? 'none' : 'auto'">
          <c11n-dropdown
            appDropdownTypeahead
            id="trust-type-dropdown"
            [labelText]="'Trust type'"
            [menuData]="trustTypeOptions"
            [placeholderText]="'Select'"
            [activeItems]="selectedTrustType ? [selectedTrustType] : []"
            (stateChange)="onTrustTypeChange($event)">
          </c11n-dropdown>
          <c11n-hint-error
            [hasError]="!validTrustTypeInput"
            [size]="'medium'"
            [errorText]="'Please make a selection'"
            hintErrorId="trust-type-error"
          ></c11n-hint-error>
        </div>
      </div>
    </div>

    <div class="trust-field-row">
      <div class="trust-field" [class.disabled]="!selectedTrustId">
        <label c11n-label for="trust-display-name" [size]="'medium'">{{ TRUST_DETAILS_TRUST_DISPLAY_NAME }}</label>
        <c11n-input [size]="'medium'">
          <input
            c11nInput
            id="trust-display-name"
            type="text"
            [(ngModel)]="trustDisplayName"
            (input)="onTrustDisplayNameChange($event)"
            [disabled]="!selectedTrustId"
          />
        </c11n-input>
        <c11n-hint-error
          [hasError]="!validTrustDisplayNameInput"
          [size]="'medium'"
          [hintText]="TRUST_DETAILS_DISPLAY_NAME_DESC"
          [errorText]="'This field is required'"
          hintErrorId="display-name-error"
        ></c11n-hint-error>
      </div>

      <div class="trust-field" [class.disabled]="!selectedTrustId || selectedTrust?.source === 'VANGUARD'">
        <label c11n-label for="trust-legal-name" [size]="'medium'">Legal trust name</label>
        <c11n-input [size]="'medium'">
          <input
            c11nInput
            id="trust-legal-name"
            type="text"
            [(ngModel)]="trustLegalName"
            (input)="onTrustLegalNameChange($event)"
            [disabled]="!selectedTrustId || isVanguardTrust()"
          />
        </c11n-input>
        <c11n-hint-error
          [hasError]="!validTrustLegalNameInput"
          [size]="'medium'"
          [hintText]="TRUST_DETAILS_LEGAL_NAME_DESC"
          [errorText]="'This field is required'"
          hintErrorId="legal-name-error"
        ></c11n-hint-error>
      </div>
    </div>
  </ng-container>
</div>
